<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 nopads">
    <Transition name="fade">
      <div v-if="sewerDrains.length > 0" class="list-content result-table">
        <vue3-datatable
          ref="resultTable"
          :rows="sewerDrains"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        >
          <template #status="row">
            {{ row.value.status ? getStatusString(row.value.status) : '' }}
          </template>
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>

import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'StormSewerDrainList',
    components: {Vue3Datatable},
    mixins: [stormSewersMixin],
    props: {
        stormSewerDrains: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            sewerDrains: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'contracts_display', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('storm_sewers.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'radius', title: this.$t('storm_sewers.radius'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'material_display', title: this.$t('storm_sewers.material'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        stormSewerDrains() {
           this.processSewerDrains()
        }
    },
    mounted() {
        this.processSewerDrains()
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        },
        getFormattedValue: function (value) {
            if (!value || value < 1) {
                return ""
            }
            return value
        },
        processSewerDrains() {
            this.sewerDrains = []
            let temp = []
            const materialOptions = this.getMaterialOptions()

            this.stormSewerDrains.forEach(item => {
                let newItem = JSON.parse(JSON.stringify(item))

                const materialFound = materialOptions.find(m => m.value == newItem.material)
                newItem.material_display = materialFound ? materialFound.text : newItem.material

                if (Array.isArray(newItem.contracts) && newItem.contracts.length > 0) {
                    newItem.contracts_display = newItem.contracts
                        .map(c => c && c.name ? c.name : '')
                        .filter(n => n) // remove empty
                        .join(', ')
                } else if(newItem.contract && newItem.contract.name) {
                    newItem.contracts_display = newItem.contract.name
                }

                temp.push(newItem)
            })

            this.sewerDrains = temp
        }
    }
}
</script>
